import React, { useContext, useRef, useState, lazy } from "react"
import { Box, Typography, Button, ButtonGroup, Dialog, DialogActions, DialogContent, DialogTitle, Drawer, FormLabel, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme, Stepper, Step, StepButton, Divider, Alert, List, ListItem, Accordion, AccordionSummary, AccordionDetails, AccordionActions } from "@mui/material"
import __t from "../../../lib/traduzioni"
import BSSPreventivoContext from "../../../contexts/BSSPreventivoContext"
import useBSSLogger from "../../../hooks/useBSSLogger"
import { ArrowBackIos, Cancel, CheckCircleOutline, Edit as EditIcon, ExpandMore, KeyboardArrowRight, Visibility } from "@mui/icons-material"
import Preventivo from "../Preventivo"


import currencies from "../../../currencies"
import { getClosest } from "../../Wrapper"
import BSSDrawer from "../../form/BSSDrawer"
import BSSDialog, { BSSDialogWithActions } from "../../form/BSSDialog"
import BSSDataContext from "../../../contexts/BSSDataContext"

const {logger} = useBSSLogger();

const sup3 = "³";

const labelLocalita = (contesto, datiPregressi) => {
    let str = "";

    const isonaz = datiPregressi?.[`nazione_${contesto}`]?.iso ?? `${__t("nazione")} ${__t("undefined", ["a"])}`;
    const cap = datiPregressi?.[`comune_${contesto}`]?.cap ?? datiPregressi?.[`cap_comune_${contesto}`] ?? `${__t("cap")} ${__t("undefined", ["o"])}`;
    const comune = datiPregressi?.[`comune_${contesto}`]?.comune ?? datiPregressi?.[`comune_comune_${contesto}`] ?? `${__t("comune")} ${__t("undefined", ["o"])}`;

    str = `${comune} (${isonaz}) - ${cap}`

    return str;
}

const labelIndiceCollo = ({tipo, indice}) => {
    let str = ``;
    
    if(tipo !== undefined && indice !== undefined){
        str = `${tipo} #${indice + 1}`
    }

    return str
}

const labelCollo = ({larghezza, lunghezza, altezza, peso, qta, tipo = undefined, indice = undefined}) => {
    let str = ``;
        
    str = `${str} ${qta} x (${lunghezza} x ${altezza} x ${larghezza})cm${sup3}, ${peso} Kg`

    return str;
}

const nextUrlByStep = (step, flashMessages = null) => {
    const idNextUrl = spedizioniweb2?.paginepreventivo?.[`step${step}`] ?? null;
    let nextUrl = null;
        
    if(idNextUrl !== null){
        const post = spedizioniweb2?.paginearticoli.find(p => Number(p.ID) === Number(idNextUrl));
        if(post !== undefined){
            nextUrl = post.guid ?? null
        }
    }

    if(nextUrl !== null && Array.isArray(flashMessages) && flashMessages.length){
        localStorage.setItem("spedizioniweb2_flashMessages", JSON.stringify({[idNextUrl]: flashMessages}))
    }

    return nextUrl;
}

const nextUrlByUrl = (url, flashMessages = null) => {
    localStorage.setItem("spedizioniweb2_flashMessages", JSON.stringify({"*": flashMessages}));
    return url;
}

const getNextUrl = (url, step, messages) => {
    let resUrl = null;
    if(![null, undefined].includes(url)){
        resUrl = nextUrlByUrl(url, messages) 
    } else if(![null, undefined].includes(step)){
        resUrl = nextUrlByStep(step, messages)
    }

    return resUrl;

}

const RiepilogoAddizionali = ({preventivoStorage, valuta, theme}) => {

    const {addizionali, preventivoSelezionato} = preventivoStorage;

    const {listaaddizionali = []} = preventivoSelezionato;
    const {prodotto = null} = preventivoSelezionato?.price?.associazione;

    let addizionaliProdottoScelti = [];

    if(prodotto !== null){
        
        /**
         * mappa che ha per chiavi
         * addizionale_{idaddizionale}
         * e per valore il valore inserito dall'utente
         */
        const addizionaliProdotto = addizionali?.[`prodotto_${prodotto.id}`] ?? {};


        addizionaliProdottoScelti =  Object.keys(addizionaliProdotto).reduce((arr, chiaveAddizionale) => {
            
            const [_, idaddizionale] = chiaveAddizionale.split("_");

            const addizionale = listaaddizionali.find(({id}) => Number(id) === Number(idaddizionale));

            return [
                ...arr,
                {
                    ...addizionale,
                    valoreUtente: addizionaliProdotto[chiaveAddizionale]
                }
            ]

        }, []).filter(addizionale => {

            const {nome: {testo}, tipo: {value: tipoadd}, valoreUtente} = addizionale;

            let esito = false; 

            if(["D", "I"].includes(tipoadd)){
                if(Number(valoreUtente) !== 0){
                    esito = true;
                }
            } else {
                esito = valoreUtente;
            }

            return esito;
        });
    }


    return (
        addizionaliProdottoScelti.length > 0 && (

            <>
            <Box >
                {__t("serviziscelti")}:
            </Box>
            <Box pb={2}>
                <List >
                    {addizionaliProdottoScelti
                        .map((addizionale, indiceAdd) => {

                        const {nome: {testo}, tipo: {value: tipoadd}, valoreUtente} = addizionale;

                        

                        return (
                            <ListItem key={indiceAdd} style={{paddingLeft: 0, paddingRight: 0}} >
                                <Box style={{width: "100%"}} display={"flex"}>
                                    <Box flexGrow={1}>
                                        {testo} {["D", "I"].includes(tipoadd) ? `${__t("per")} ` : ''}                                        
                                    </Box>
                                    <Box  pl={1}>
                                        {["D", "I"].includes(tipoadd) ?
                                            (<b>{valuta.symbol} {Number(valoreUtente).toFixed(valuta.decimal_digits)}</b>):
                                            (<CheckCircleOutline color="success" />)
                                        }
                                        
                                    </Box>
                                </Box>
                            </ListItem>
                        )
                    })}
                </List>
            </Box>
                
            </>

            
        )        
    )
}

const RiepilogoColli = ({tipoSpedizione, colli}) => {
    return (
        <TableContainer component={Paper}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell colSpan={3} align="center">
                            {__t("riepilogo")} {tipoSpedizione?.descrizione ?? __t("tipospedizione")+" "+__t("undefined", ["a"]) }
                        </TableCell>
                    </TableRow>
                    <TableRow>                                                        
                        <TableCell>
                            {__t("misure")} (cm{sup3})
                        </TableCell>
                        <TableCell>
                            {__t("peso")}
                        </TableCell>
                        <TableCell>
                            {__t("qta")}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(colli ?? []).map((collo, indiceCollo) => {
                        return (
                            <TableRow key={indiceCollo}>                                          
                                <TableCell>
                                    {collo.lunghezza ?? 0} x  {collo.altezza ?? 0} x {collo.larghezza ?? 0} 
                                </TableCell>                                                                                
                                <TableCell>
                                    {collo.peso ?? 0}
                                </TableCell>    
                                <TableCell>
                                    {collo.qta ?? 0}
                                </TableCell>                                                                            
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
            
        </TableContainer>
    )
}

const FrammentoRiepilogo = ({methods, classes, step = 2}) => {

    const theme = useTheme()

    const {datiPregressi, tipiSpedizione, preventivoStorage} = useContext(BSSPreventivoContext)

    const [mostraPreventivo, setMostraPreventivo] = useState(false)
    const [drawerColli, setDrawerColli] = useState({open: false})

    const {preventivi = {}} = preventivoStorage;

    const valuta = currencies[preventivi?.currency ?? "EUR"];

    const {
        nazione_partenza, 
        nazione_arrivo, 
        comune_partenza, 
        comune_arrivo, 
        cap_comune_partenza, 
        comune_comune_partenza, 
        cap_comune_arrivo, 
        comune_comune_arrivo,
        tipoSelezionato,
        colli
    } = datiPregressi

    
    const tipoSpedizione = tipiSpedizione.find(ts => ts.id === tipoSelezionato);

    const labelTipoSpedizione = () => {
        let str = "";

        const tipo = tipiSpedizione.find(ts => ts.id === tipoSelezionato);
        const ncolli = colli?.length ?? 0;

        str = `${__t("staispedendo")} ${ncolli} ${tipo?.multiDescr?.testo ?? __t("tipospedizione")+" "+__t("undefined", ["a"])}`;

        return str;
    }

    

    const modifica = () => {        
        setMostraPreventivo(true);
    }

    const handleClose = async (modificaPreventivo) => {
        if(!modificaPreventivo) {
            setMostraPreventivo(false);
        }

        location.reload()
    }

    const propsRiepilogo = {
        classes,
        datiPregressi,
        labelLocalita,
        tipoSpedizione,
        colli,
        setDrawerColli,
        drawerColli,
        preventivoStorage,
        theme,
        valuta,
        step,
        mostraPreventivo,
        handleClose,
        modifica,
    }

    return (
        <>
            <RiepilogoAStep {...propsRiepilogo} />
            {/* <Riepilogo {...propsRiepilogo} /> */}

            <BSSDialogWithActions fullWidth maxWidth="lg" open={mostraPreventivo} 
                closeHandler={e => handleClose(false)} aria-labelledby="form-dialog-title"
                title={`${__t("modifica")} ${__t("preventivo")}`}
                actions={[
                    (<div key={`destSubmitPopupDaPrezzi_${step-1}`} id={`destSubmitPopupDaPrezzi_${step-1}`}></div>),
                    <Button key={"button_annulla"} onClick={e => handleClose(false)} color="secondary">
                        {__t("annulla")}
                    </Button>
                ]}
            >
                <Preventivo 
                    fromStep={step-1}
                    step={step-1}
                    cfgSubmitStep1={{wrapped: false, buttonProps: {variant: 'text'}}} 
                    nextUrl={nextUrlByStep(step)} 
                    destSubmit={`destSubmitPopupDaPrezzi_${step-1}`} />                     
            </BSSDialogWithActions>

            
        </>
            
    )
}

const RiepilogoAStep = ({
    classes,
    datiPregressi,
    labelLocalita,
    tipoSpedizione,
    colli,
    setDrawerColli,
    drawerColli,
    preventivoStorage = {},
    theme,
    valuta,
    step,
    mostraPreventivo,
    handleClose,
    modifica,
}) => {

    const [mostraInfoStep, setMostraInfoStep] = useState()

    const {shadowBody} = useContext(BSSDataContext);
    logger.debug("test shadowbody per RiepilogoAStep", shadowBody)

    const steps = [
        __t("step1"),
        __t("step2"),
        __t("step3"),
        __t("step4"),
    ]

    const stepCompleted = indiceStep => {
        return indiceStep < step-1
    }

    const handleStepClick = (e, indiceStep) => {
        if(indiceStep < (step - 1)) {
            setMostraInfoStep(mostraInfoStep !== indiceStep ? indiceStep : null)
        }
    }

    const {preventivoSelezionato = {}} = preventivoStorage;
    const {printerrequired = true} = preventivoSelezionato;

    const StepsDetail = [
        step > 1 ? (
            <>
                <Box py={2}>
                    <Box display={"flex"}>
                        <Box flexGrow={1}>
                            {__t("da")}: 
                        </Box>
                        <Box pl={1}>
                            <b>{labelLocalita("partenza", datiPregressi)}</b>
                        </Box>
                    </Box>
                </Box>
                <Box py={2}>
                    <Box display={"flex"}>
                        <Box flexGrow={1}>
                            {__t("a")}: 
                        </Box>
                        <Box pl={1}>
                            <b>{labelLocalita("arrivo", datiPregressi)}</b>
                        </Box>
                    </Box>
                </Box>  
                <Box py={2}>
                    <RiepilogoColli {...{colli, tipoSpedizione}} />
                </Box>             
            </>
        ) : "",
        step > 2 ? (
            <>
                <Box pb={2}>
                    <Alert severity={printerrequired ? "warning" : "info"}>
                        {__t(printerrequired ? "printrequired" : "printnotrequired")}
                    </Alert>
                </Box>
                <Box pb={2}>                    
                    <Box display={"flex"}>
                        <Box flexGrow={1}>
                            {__t("preventivoscelto")}:
                        </Box>
                        <Box pl={1}>
                            <b>{preventivoStorage.preventivoSelezionato.description}</b>
                        </Box>
                    </Box>                   
                </Box>                                                            

                <Box py={2}>
                    <RiepilogoAddizionali {...{preventivoStorage, valuta, theme}} />
                </Box>
                <Box pt={2}>
                    <Box display={"flex"}>
                        <Box flexGrow={1} > 
                            <Typography variant={"h6"}>                                           
                                {__t("totale")}:              
                            </Typography>
                        </Box>                                    

                        <Box>
                            <Typography variant={"h6"}>
                                <b>{valuta.symbol} {preventivoStorage.preventivoSelezionato.totalprice.toFixed(valuta.decimal_digits)}</b>
                            </Typography>
                        </Box>
                    </Box>

                </Box>
            </>
        ): ""        
    ]


    return (
        <>

            <Box sx={{ width: "100%"}} p={2}>
                <Stepper activeStep={step-1} alternativeLabel>
                    {steps.map((labelStep, indiceStep) => (
                        <Step key={labelStep} completed={stepCompleted(indiceStep)}>
                            <StepButton color={theme.palette.primary.main} 
                                onClick={e => handleStepClick(e, indiceStep)}
                            >
                                {labelStep}
                            </StepButton>
                            
                        </Step>
                    ))}
                </Stepper>
            </Box>
            
            <BSSDrawer open={(mostraInfoStep ?? null) !== null} style={{zIndex: 999999}} onClose={e => setMostraInfoStep(null)}>
                <DialogTitle disableTypography className="drawerTitle" sx={{display: "flex", justifyContent: "flex-end", padding: "0"}}>
                    <IconButton size ="large" onClick={e => setMostraInfoStep(null)}>
                        <Cancel color="secondary" />
                    </IconButton>
                </DialogTitle>
                
                {[steps[0], steps[1]].map((stepLabel, stepIndice) => {

                    const Dettaglio = StepsDetail[stepIndice];

                    return (
                        <Accordion key={stepIndice} expanded={mostraInfoStep === stepIndice} 
                            onChange={e => setMostraInfoStep(stepIndice)} 
                            disabled={step - 2 < stepIndice}
                        >
                            <AccordionSummary expandIcon={<ExpandMore />}>
                                <Typography variant="h6">
                                    {stepLabel}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {Dettaglio}                        
                            </AccordionDetails>
                            <AccordionActions>
                                <Box sx={{width: "100%"}}>
                                    <Button fullWidth variant={"contained"} onClick={e => {
                                        location.href = nextUrlByStep(stepIndice+1)
                                    }}>
                                        <ArrowBackIos /> {__t("tornaastep")} {stepLabel}
                                    </Button>
                                </Box>
                            </AccordionActions>
                        </Accordion>
                    )
                })}
            </BSSDrawer>
            
            
            
        </>
    )
}

export default FrammentoRiepilogo
export {labelLocalita, labelCollo, labelIndiceCollo, nextUrlByStep, nextUrlByUrl, getNextUrl}